import { useEffect } from 'react';

import Cookies from 'js-cookie';

import { PREVIEW_COOKIE_NAME } from './eligibility';
import { SPLIT_TEST_NAME } from '../../AnonymousSplitTest/SPLIT_TESTS';
import { clearCreditCheckVisited } from '../../helpers/creditCheckSession';

const PARAM_NAME = 'mobilePreview';
const SPLIT_COOKIE_NAME = `iw-${SPLIT_TEST_NAME.DE_MOBILE_SIGNUP_V1}`;
const forcedSplitCookie = (branchName: 'INCLUDE' | 'EXCLUDE') =>
  JSON.stringify({
    test_name: SPLIT_TEST_NAME.DE_MOBILE_SIGNUP_V1,
    branch_name: branchName,
  });

export const applyMobilePreviewOverride = (
  search: string,
): 'set' | 'cleared' | 'none' => {
  const value = new URLSearchParams(search).get(PARAM_NAME);

  // Pre-seeding the split cookie keeps forced testers out of the enrolment POST,
  // so they never land in the measured arms.
  if (value === 'true') {
    Cookies.set(PREVIEW_COOKIE_NAME, 'true');
    Cookies.set(SPLIT_COOKIE_NAME, forcedSplitCookie('INCLUDE'));
    // An explicit opt-in must win over an earlier credit-check visit in the same tab.
    clearCreditCheckVisited();
    return 'set';
  }

  // Removing the cookies would re-roll the live split, so pin EXCLUDE instead.
  if (value === 'false') {
    Cookies.remove(PREVIEW_COOKIE_NAME);
    Cookies.set(SPLIT_COOKIE_NAME, forcedSplitCookie('EXCLUDE'));
    return 'cleared';
  }

  return 'none';
};

export const useMobilePreviewOverride = (): void => {
  useEffect(() => {
    const result = applyMobilePreviewOverride(window.location.search);
    if (result === 'none') return;

    const url = new URL(window.location.href);
    url.searchParams.delete(PARAM_NAME);
    window.location.replace(url.toString());
  }, []);
};
